import axios from "axios";
import { getApiBaseUrl } from "../../config.js";

const apiPrefix = getApiBaseUrl("xmot");

export const getUsersLocations = async (token, reqBody) => {
  return await axios.post(`${apiPrefix}/api/v1/users-locations`, reqBody, {
    headers: {
      Token: `${token}`,
    },
  });
};

export const sessionSegmentListing = async (token, reqBody) => {
  return await axios.post(
    `${apiPrefix}/api/v1/session-segment-listing`,
    reqBody,
    {
      headers: {
        Token: `${token}`,
      },
    },
  );
};

export const getSessionDropdownList = async (token, reqBody) => {
  return await axios.post(
    `${apiPrefix}/api/v1/xmot/session-dropdown`,
    reqBody,
    {
      headers: {
        Token: `${token}`,
      },
    },
  );
};

export const fetchSessionChartsData = async (token, reqBody) => {
  return await axios.post(`${apiPrefix}/api/v1/xmot/ai-responses`, reqBody, {
    headers: {
      Token: `${token}`,
    },
  });
};

export const fetchSessionQuantChartsData = async (token, reqBody) => {
  return await axios.post(`${apiPrefix}/api/v1/ai-response-quant`, reqBody, {
    headers: {
      Token: `${token}`,
    },
  });
};
